import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useAlert, types } from 'react-alert';
import { useTranslation } from 'react-i18next';
import { useAuthUser } from '../../../model/hooks';
export const RedirectCheckChlinic = () => RedirectCheck('clinicUser');
export const RedirectCheckAdmin = () => RedirectCheck('adminUser');
export const RedirectCheck = (value) => {
    const history = useHistory();
    const reactAlert = useAlert();
    const { t } = useTranslation();
    const { userType } = useAuthUser();
    useEffect(() => {
        if (userType && userType !== value) {
            history.push('/');
            reactAlert.show(`${t('ログアウトしました')}${'\n'}${t('再ログインしてください')}`, { type: types.INFO });
        }
    }, [userType, value]);
    return null;
};
export const RedirectLogin = () => {
    const history = useHistory();
    const reactAlert = useAlert();
    const { t } = useTranslation();
    const { userType } = useAuthUser();
    useEffect(() => {
        if (userType === 'clinicUser') {
            history.push('/home');
            reactAlert.show(t('ログインしました'), { type: types.SUCCESS });
        }
        else if (userType === 'adminUser') {
            history.push('/admin');
            reactAlert.show(t('ログインしました'), { type: types.SUCCESS });
        }
    }, [history, userType]);
    return null;
};
